import { Component, OnInit, Inject, HostListener, ElementRef } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA, MdDialog, MdDialogConfig } from '@angular/material';

import { BookingService } from 'app/services/booking/booking.service';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { DialogAlertComponent } from '../modal/dialog-alert/dialog-alert.component';
import * as moment from 'vendors/moment-locale-th';
import { PaymentMethodDetailType } from 'app/model/constant';

export class DialogCancellationData {
  bookingId: string;
  ref?: any;
  type?: string;
  onSubmit: any;
}

class PaymentCreditTermShareBudget {
  mainBooker: number;
  coBooker: number;
}

class BookerCancellationCharge {
  paymentType: string;
  mainBooker?: boolean;
  totalCharge: number;
}

export class DialogCancellationResponse {
  bookingId: string;
  ref: any;
  done: any;
  reason: string;

  constructor(bookingId: string, ref: any, done: any, reason: string) {
    this.bookingId = bookingId;
    this.ref = ref;
    this.done = done;
    this.reason = reason;
  }
}

class DisplayPaymentNonCreditTerm {
  title: string;
  paymentId: string;
  totalCancellationFee: number
}

const ID_PAYMENT = {
  MAIN_PAYMENT: 'main-payment',
  ANOTHER_PAYMENT: 'another-payment',
}
@Component({
  selector: 'ota-dialog-cancellation-booking',
  templateUrl: './dialog-cancellation-booking.component.html',
  styleUrls: ['./dialog-cancellation-booking.component.scss']
})

export class DialogCancelBookingComponent implements OnInit {
  public lang: string;
  public cancelBookingId: string;
  public cancellationChargeList: any;
  public cancelBookingListState = 'LOADING';
  public cancellationFee: number;
  public cancellationDate: any;
  public getBookingCancellationDataRequest: any;
  public isCancelling = false;
  public isShareBudget = false;

  public isCreditTerms = false;
  public isDisplayRefundPolicy = false;
  public isDisplayPromotionPolicy = false;

  public paymentCreditTerms = null;
  public paymentCreditTermsShareBudget: PaymentCreditTermShareBudget = null;
  public paymentCreditCard = null;
  public paymentTrueMoneyWallet = null;
  public paymentCorporateFleet = null;
  public paymentPersonalFleet = null;

  public displayPaymentNonCreditTermList: DisplayPaymentNonCreditTerm[] = [];

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    document.documentElement.style.setProperty('--dialog-filter-vh', `${window.innerHeight * 0.01}px`);
  }

  constructor(
    public dialogRef: MdDialogRef<DialogCancelBookingComponent>,
    private bookingService: BookingService,
    private utilitiesService: UtilitiesService,
    private appConfigService: AppConfigService,
    private dialog: MdDialog,
    private el: ElementRef,
    @Inject(MD_DIALOG_DATA) private data: DialogCancellationData
  ) { }

  reasonText: string;
  isReasonError: boolean;

  ngOnInit() {
    this.onResize();
    this.fetchData();
  }

  fetchData() {
    this.cancelBookingListState = 'LOADING';
    if (this.getBookingCancellationDataRequest) {
      this.getBookingCancellationDataRequest.unsubscribe();
    }
    this.getBookingCancellationDataRequest = this.bookingService.getBookingCancellationFee(this.data.bookingId)
      .subscribe((res) => {
        const { data } = res;
        this.cancelBookingId = data.bookingId;
        this.cancellationChargeList = data.cancellationChargeList;
        this.cancellationFee = data.totalCharge;
        this.isDisplayRefundPolicy = data.displayRefundPolicy;
        this.isDisplayPromotionPolicy = data.displayPromotionPolicy;

        if (this.cancellationChargeList && this.cancellationChargeList.length > 0) {
          this.cancelBookingListState = 'SUCCESS';
          this.lang = this.appConfigService.getLanguage();
          this.cancellationChargeList = this.cancellationChargeList.map((item: any) => {
            return {
              ...item,
              cancellationDate: item.fromDate ? moment(item.fromDate).locale(this.lang).format('DD MMM YY') : undefined,
            };
          });
        } else {
          this.cancelBookingListState = 'FREE';
        }

        if (data.bookerCancellationChargeList !== undefined) {
          const bookerCancellationChargeList: BookerCancellationCharge[] = data.bookerCancellationChargeList;
          if (bookerCancellationChargeList.filter(cancellation => cancellation.paymentType === PaymentMethodDetailType.CREDIT_TERMS).length > 1) {
            this.isShareBudget = true;
            this.paymentCreditTermsShareBudget = new PaymentCreditTermShareBudget();
          }

          this.displayPaymentNonCreditTermList = [];
          for (let i = 0; i < bookerCancellationChargeList.length; i++) {
            if (bookerCancellationChargeList[i].paymentType === PaymentMethodDetailType.CREDIT_TERMS) {
              this.isCreditTerms = true;
              if (this.isShareBudget) {
                if (bookerCancellationChargeList[i].mainBooker) {
                  this.paymentCreditTermsShareBudget.mainBooker = bookerCancellationChargeList[i].totalCharge;
                } else {
                  this.paymentCreditTermsShareBudget.coBooker = bookerCancellationChargeList[i].totalCharge;
                }
              } else {
                this.paymentCreditTerms += bookerCancellationChargeList[i].totalCharge;
              }
            } else {
              const displayPaymentNonCreditTerm = new DisplayPaymentNonCreditTerm();
              switch (bookerCancellationChargeList[i].paymentType) {
                case PaymentMethodDetailType.CREDIT_CARD:
                  displayPaymentNonCreditTerm.title = 'booking-cancellation-credit-card'
                  break;
                case PaymentMethodDetailType.TRUE_MONEY:
                  displayPaymentNonCreditTerm.title = 'booking-cancellation-true-money'
                  break;
                case PaymentMethodDetailType.CORPORATE_FLEET:
                  displayPaymentNonCreditTerm.title = 'booking-cancellation-corporate-fleet'
                  break;
                case PaymentMethodDetailType.PERSONAL_FLEET:
                  displayPaymentNonCreditTerm.title = 'booking-cancellation-personal-fleet'
                  break;
                default:
                  displayPaymentNonCreditTerm.title = ''
                  break;
              }
              displayPaymentNonCreditTerm.paymentId = i === 0 ? ID_PAYMENT.MAIN_PAYMENT : ID_PAYMENT.ANOTHER_PAYMENT;
              displayPaymentNonCreditTerm.totalCancellationFee = bookerCancellationChargeList[i].totalCharge;
              this.displayPaymentNonCreditTermList.push(displayPaymentNonCreditTerm);
            }
          }
        }
      }, err => {
        this.dialogRef.close();
        const dialogAlertRef: MdDialogRef<DialogAlertComponent> = this.dialog.open(DialogAlertComponent);
        dialogAlertRef.componentInstance.alertText = this.appConfigService.getTranslate('approval-action-unable-approval-or-reject-detail');
        dialogAlertRef.componentInstance.imageSrc = '/assets/images/icons/icon-failed.png';
        dialogAlertRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-failed.png';
      });
  }

  cancelBooking() {
    if (this.data.type === 'approval') {
      if (this.isReasonError === false) {
        this.isCancelling = true;
        this.data.onSubmit(new DialogCancellationResponse(this.data.bookingId, this.data.ref, this.done.bind(this), this.reasonText));
      } else {
        this.isReasonError = true;
      }
    } else {
      this.isCancelling = true;
      this.data.onSubmit(new DialogCancellationResponse(this.data.bookingId, this.data.ref, this.done.bind(this), this.reasonText));
    }
  }

  done() {
    this.dialogRef.close();
  }

  onKeyupReason(text: string) {
    this.isReasonError = text && text.trim().length > 0 ? false : true;
    this.reasonText = text;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dialog-cancellation-booking/dialog-cancellation-booking.component.ts